import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Company } from '../../user/clients/clients-list';
export interface IFirm {
  _id?: string;
  user_id: string;
  active: boolean;
  companies: Company[];
  ownerId: string;
  name: string;
  users?: string[];
}

export interface FirmState {
  currentFirm: IFirm | null;
}

const initialState: FirmState = {
  currentFirm: null
};

export const firmSlice = createSlice({
  name: 'currentFirm',
  initialState,
  reducers: {
    setCurrentFirm: (state, action: PayloadAction<IFirm | null>) => {
      state.currentFirm = action.payload;
    },
    resetCurrentFirm: (state) => {
      state.currentFirm = null;
    }
  }
});

// Action creators are generated for each case reducer function
export const { setCurrentFirm, resetCurrentFirm } = firmSlice.actions;

export default firmSlice.reducer;
